
import Steps from "../plannings/steps/steps.coffee"

export default class LoadTabs
  @init: ->
    @add_listeners()
    @load_first_tab()

  @add_listeners: ->
    $(document).on 'click', '.tab-lazy-load', (e) =>
      e.preventDefault()
      link = $(e.currentTarget)
      tabId = link.data('tab')
      stepGroupId = link.data('step-group-id')
      isLoaded = link.data('loaded')

      # Ativar a aba clicada
      link.parent().addClass('active').siblings().removeClass('active')

      # Esconder todas as abas e mostrar a clicada
      $('.js-step-component').hide()
      $(tabId).show()

      # Carregar conteúdo se ainda não foi carregado
      unless isLoaded
        @load_tab_content(stepGroupId, tabId, link)

  @load_first_tab: ->
    firstTab = $('.tab-lazy-load').first()
    return unless firstTab.length > 0

    tabId = firstTab.data('tab')
    stepGroupId = firstTab.data('step-group-id')

    # Ativar primeira aba
    firstTab.parent().addClass('active')

    # Mostrar apenas primeira aba
    $('.js-step-component').hide()
    $(tabId).show()

    # Carregar conteúdo da primeira aba
    @load_tab_content(stepGroupId, tabId, firstTab)

  @load_tab_content: (stepGroupId, tabId, link) ->
    container = $(tabId)

    $.ajax
      url: "/atividades/load_tab_content"
      method: 'GET'
      data: { step_group_id: stepGroupId }
      beforeSend: ->
        container.find('.loading-tab').show()
      success: (data) =>
        container.html(data)
        link.data('loaded', true)

        # Re-inicializar LoadServices para os novos steps carregados
        if typeof LoadServices != 'undefined'
          LoadServices?.init()

        loadHistoryModalListener();
        new Steps.add_listeners()
      error: ->
        container.html('<div class="alert alert-danger">Erro ao carregar conteúdo da aba</div>')
